import ReactDOM from 'react-dom/client'
import './index.css'
import AppProvider from './providers/AppProvider';
import './css/satoshi.css';
import 'jsvectormap/dist/css/jsvectormap.css';
import 'flatpickr/dist/flatpickr.min.css';

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <AppProvider />
)